<template>
  <div>
    <div class="custom-control custom-control-inline custom-checkbox" style="margin-left: -5px">
      <input class="custom-control-input" type="checkbox" v-model="checked" :name="`formData[${currentField.tagname}]`" /> &nbsp;<span class="labelized custom-control-label" @click="checked = !checked">{{ currentField.label }} {{ req() ? '*' : '' }}</span>
    </div>
    <span class="invalid-feedback" role="alert" v-if="error">
        <strong>{{ error }}</strong>
    </span>
  </div>
</template>

<script>
import fetchData from '@/api/fetch-data';
export default {
  name: 'Flag',
  props: ['currentField', 'error', 'value', 'overrideRequired'],
  data() {
    return {
      checked: this.value ?? false
    }
  },

  watch: {
    value (value) {
      this.checked = value ?? false
    },

    checked(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value: value ?? null,
      })
    }
  },

  methods: {
      req() {
          if(this.overrideRequired) {
              return this.overrideRequired
          }

          return this.currentField.isRequired
      }
  },

  mounted() {
    if (this.currentField.isFromFormList) {
      let dataUrl = '/lists/' + this.currentField.formListTag;
      let valueField = 'value';
      let labelField = 'label';
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        // console.log(data)
        this.currentField.options = data;
      });
    }
  }
}
</script>

<style>
.el-checkbox-group {
  font-size: 14px;
}
.labelized {
    font-family: "Brandon Regular", Helvetica, sans-serif;
    color: #6C6C6C;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
}
</style>
